// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pc-container[data-v-6a997abb]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;min-width:1280px;min-height:100vh}.pc-content[data-v-6a997abb]{min-height:calc(100vh - 68px)}.__nuxt-error-page[data-v-6a997abb]{position:relative}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
